import mongoose from 'mongoose';
import {
  equals, compose, map, contains, any, keysIn,
} from 'ramda';

const { Schema } = mongoose;

const Permissions = new Schema(
  {
    action: String,
    resource: String,
    allowed: Boolean,
  },
  { _id: false },
);

const ProtektorRolesSchema = new Schema({
  roleIdentifier: {},
  permissions: [Permissions],
});

ProtektorRolesSchema.index(
  { roleIdentifier: 1 },
  { unique: false, background: true, dropDups: false },
);

ProtektorRolesSchema.index(
  { 'roleIdentifier.displayName': 1, 'roleIdentifier.team': 1 },
  { unique: true, background: true, dropDups: false },
);

ProtektorRolesSchema.index(
  { roleIdentifier: 1, permissions: 1 },
  { unique: true, background: true, dropDups: false },
);

const roleIdentifierToQuery = (roleIdentifier) => {
  const isTrue = equals(true);
  const containsRoleIdentifier = compose(
    any(isTrue),
    map(contains('roleIdentifier.')),
    keysIn,
  );

  return containsRoleIdentifier(roleIdentifier)
    ? roleIdentifier
    : { roleIdentifier };
};

ProtektorRolesSchema.statics.insertAllow = (
  action,
  resource,
  roleIdentifier,
) => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  const permissions = { action, resource, allowed: true };
  const roleQuery = roleIdentifierToQuery(roleIdentifier);

  return ProtektorRoles.findOneAndUpdate(
    roleQuery,
    { $addToSet: { permissions } },
    {
      new: true,
      overwrite: false,
      upsert: true,
      strict: false,
    },
  ).lean();
};

ProtektorRolesSchema.statics.insertForbid = (
  action,
  resource,
  roleIdentifier,
) => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  const permissions = { action, resource, allowed: false };
  const roleQuery = roleIdentifierToQuery(roleIdentifier);

  return ProtektorRoles.findOneAndUpdate(
    roleQuery,
    { $push: { permissions } },
    {
      new: true,
      overwrite: false,
      upsert: true,
      strict: false,
    },
  ).lean();
};

ProtektorRolesSchema.statics.removePermission = async (
  action,
  resource,
  roleIdentifier,
) => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  const roleQuery = roleIdentifierToQuery(roleIdentifier);

  return ProtektorRoles.findOneAndUpdate(
    roleQuery,
    { $pull: { permissions: { action, resource } } },
    {
      new: true,
      overwrite: false,
      upsert: true,
      strict: false,
    },
  ).lean();
};

ProtektorRolesSchema.statics.removeRole = (roleIdentifier) => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  const roleQuery = roleIdentifierToQuery(roleIdentifier);

  return ProtektorRoles.findOneAndDelete(roleQuery).lean();
};

ProtektorRolesSchema.statics.findRole = (roleIdentifier) => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  const roleQuery = roleIdentifierToQuery(roleIdentifier);

  return ProtektorRoles.findOne(roleQuery).lean();
};

ProtektorRolesSchema.statics.findAllRoles = () => {
  const ProtektorRoles = mongoose.model(
    'protektorroles',
    ProtektorRolesSchema,
    'ProtektorRoles',
  );
  return ProtektorRoles.find({}).lean();
};

export default () => mongoose.model('protektorroles', ProtektorRolesSchema, 'ProtektorRoles');
